import styled, { css } from 'styled-components';

const Container = styled.div`
  margin: 10px 0;
  border-bottom: 2px solid #bbbdbf;
  padding-bottom: 7px;
  margin-bottom: 20px;
`;
const Heading = styled.div`
  text-align: center;
  font-size: 22px;
  padding: 10px;
`;
const StepSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  max-width: 570px;
  margin: 0 auto;
  @media (max-width: 460px) {
    flex-direction: column;
  }
`;
const Img = styled.img`
  max-width: 99%;
`;
const Text = styled.div``;
const Step = styled.div`
  padding: 0.5% 0.5%;
  max-width: 160px;
  width: 100%;
  ${(props) =>
    props.disabled &&
    css`
      ${Img} {
        opacity: 0.4;
      }
      ${Text} {
        text-decoration: line-through;
      }
    `}
`;

const Description = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
`;

export { Container, Heading, Step, Img, Description, Text, StepSection };
